import { render } from "./App.vue?vue&type=template&id=91c1502a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=91c1502a&lang=css"
script.render = render

export default script